export enum E2EIdentifier {
  BET_MENU = "bet-menu",
  DESKTOP_KEYPAD_BET = "desktop-keypad-bet",
  MOBILE_KEYPAD_BET = "mobile-keypad-bet",
  DESKTOP_KEYPAD_BALANCE = "desktop-keypad-balance",
  MOBILE_KEYPAD_BALANCE = "mobile-keypad-balance",
  DESKTOP_KEYPAD_WIN = "desktop-keypad-win",
  MOBILE_KEYPAD_WIN = "mobile-keypad-win",
  DESKTOP_KEYPAD_TOTAL_WIN = "desktop-keypad-total-win",
  DESKTOP_KEYPAD_FREE_ROUNDS_LEFT = "desktop-keypad-free-rounds-left",
  DESKTOP_KEYPAD_FREE_SPINS_LEFT = "desktop-keypad-free-spins-left",
  MOBILE_KEYPAD_TOTAL_WIN = "mobile-keypad-total-win",
  MOBILE_KEYPAD_FREE_ROUNDS_LEFT = "mobile-keypad-free-rounds-left",
  MOBILE_KEYPAD_FREE_SPINS_LEFT = "mobile-keypad-free-spins-left",
  DEFAULT_KEYPAD_CLOCK = "default-keypad-clock",
  DEFAULT_KEYPAD_GAME_NAME = "default-keypad-game-name",
  DEFAULT_KEYPAD_GAME_PRODUCER = "default-keypad-game-producer",
  DEFAULT_KEYPAD_SPIN_BUTTON = "default-keypad-spin-button",
  DEFAULT_KEYPAD_QUICK_SPIN_BUTTON = "default-keypad-quick-spin-button",
  MINIMAL_KEYPAD_QUICK_SPIN_BUTTON = "minimal-keypad-quick-spin-button",
  MOBILE_KEYPAD_QUICKSPIN_BUTTON = "mobile-keypad-quick-spin-button",
  DEFAULT_KEYPAD_AUTOPLAY_BUTTON = "default-keypad-autoplay-button",
  MINIMAL_KEYPAD_AUTOPLAY_BUTTON = "minimal-keypad-autoplay-button",
  MOBILE_KEYPAD_AUTOPLAY_BUTTON = "mobile-keypad-autoplay-button",
  MOBILE_KEYPAD_CLOCK = "mobile-keypad-clock",
  MOBILE_KEYPAD_GAME_NAME = "mobile-keypad-game-name",
  MOBILE_KEYPAD_GAME_PRODUCER = "mobile-keypad-game-producer",
  DEFAULT_KEYPAD_MENU_BUTTON = "default-keypad-menu-button",
  MOBILE_KEYPAD_MENU_BUTTON = "mobile-keypad-menu-button",
  DEFAULT_KEYPAD_MUTE_BUTTON = "default-keypad-mute-button",
  MOBILE_KEYPAD_MUTE_BUTTON = "mobile-keypad-mute-button",
  MENU_PAYTABLE_BUTTON = "menu-paytable-button",
  MENU_GAME_SETTINGS_BUTTON = "menu-game-settings-button",
  MENU_GAME_RULES_BUTTON = "menu-game-rules-button",
  MENU_GAME_HISTORY_BUTTON = "menu-game-history-button",
  GAME_SETTINGS_PAGE = "game-settings-page",
  GAME_SETTINGS_TOGGLE = "game-settings-toggle",
  GAME_RULES_PAGE = "game-rules-page",
  GAME_HISTORY_PAGE = "game-history-page",
  GAME_RULES_BUTTON = "game-rules-button",
  GAME_HISTORY_BUTTON = "game-history-button",
  DIALOG = "dialog",
  DIALOG_TITLE = "dialog-title",
  DIALOG_MESSAGE = "dialog-message",
  DIALOG_BUTTON = "dialog-button",
  ACTIVITY_INDICATOR = "activity-indicator",
  DESKTOP_TICKER = "desktop-ticker",
  MOBILE_TICKER = "mobile-ticker",
  MOBILE_KEYPAD_HOME_BUTTON = "mobile-keypad-home-button",
  TOPBAR_HOME_BUTTON = "topbar-home-button",
  TOPBAR_SOUND_BUTTON = "topbar-sound-button",
  TOPBAR_PLUGIN_BUTTON = "topbar-plugin-button",
  TOPBAR_CLOCK = "topbar-clock",
  PLUGIN_MENU_BUTTON = "plugin-menu-button",
  PLAY_FOR_FUN_TITLE = "play-for-fun-title",
  AUTOPLAY_ROUNDS_CONTAINER = "autoplay-rounds-container",
  AUTOPLAY_SETTINGS_CONTAINER = "autoplay-settings-container",
  AUTOPLAY_ROUNDS_BUTTON = "autoplay-rounds-button",
  AUTOPLAY_ROUNDS_LIST_CONTAINER = "autoplay-rounds-list-container",
  AUTOPLAY_TITLE = "autoplay-title",
  AUTOPLAY_ROUNDS_SUBTITLE = "autoplay-rounds-subtitle",
  AUTOPLAY_SETTINGS_SUBTITLE = "autoplay-settings-subtitle",
  AUTOPLAY_STOP_CONDITIONS_CONTAINER = "autoplay-stop-conditions-container",
  AUTOPLAY_RESET_BUTTON = "autoplay-reset-button",
  AUTOPLAY_ADVANCED_SETTING_BUTTON = "autoplay-advanced-setting-button",
  KEYPAD_BET_BUTTON = "keypad-bet-button",
  BET_VIEW_IN_CASH = "bet-view-in-cash",
  BET_VIEW_IN_COINS = "bet-view-in-coins",
  KEYPAD_PAYTABLE_BUTTON = "keypad-paytable-button",
  PAYTABLE_VIEW = "paytable-view"
}
